//of_note:this should be the store used for the auctioneer
import { configureStore } from '@reduxjs/toolkit';

//needed:import slices
import auctionItemMgmtSliceReducer from '../features/auctionItemMgmt/auctionItemMgmtSlice.js'
import homeSliceReducer from '../features/home/homeSlice.js'
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';

const persistConfig = {
  key: 'root',
  storage,
}

const persistedReducer = persistReducer(persistConfig, homeSliceReducer)



//export default configureStore({
export const store = configureStore({
    reducer: {
        //homeSlice: homeSliceReducer,
        homeSlice: persistedReducer,
        auctionItemMgmt: auctionItemMgmtSliceReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    }),

})
export const persistor = persistStore(store)
